"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relationMissEntityRule = void 0;
exports.getMissingEntityRelations = getMissingEntityRelations;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'relation-miss-entity';
const ruleName = 'entity not found in relation';
const ruleDescription = 'relations with an entity not found in the database';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('RelationMissEntityConf');
exports.relationMissEntityRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const relIgnores = reference.map(r => r.extra?.relation ? (0, databaseUtils_1.relationToRef)(r.extra?.relation) : undefined).filter(utils_1.isNotUndefined);
        const entIgnores = conf.ignores?.map(databaseUtils_1.entityRefFromId) || [];
        const entities = (0, utils_1.indexBy)(db.entities || [], databaseUtils_1.entityToId);
        return (db.relations || [])
            .map(r => getMissingEntityRelations(r, entities))
            .filter(utils_1.isNotUndefined)
            .filter(v => !relIgnores.some(i => (0, databaseUtils_1.relationRefSame)(i, (0, databaseUtils_1.relationToRef)(v.relation))))
            .map(v => ({ ...v, missingEntities: v?.missing?.filter(e => !entIgnores.some(i => (0, databaseUtils_1.entityRefSame)(i, e))) }))
            .filter(v => v.missingEntities.length > 0)
            .map(violation => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Relation ${relationName(violation.relation)}, not found entities: ${violation.missingEntities.map(databaseUtils_1.entityRefToId).join(', ')}`,
            entity: violation.missingEntities[0],
            extra: violation
        }));
    }
};
const relationName = (r) => r.name || (0, databaseUtils_1.relationToId)(r);
function getMissingEntityRelations(relation, entities) {
    const src = entities[(0, databaseUtils_1.entityRefToId)(relation.src)];
    const ref = entities[(0, databaseUtils_1.entityRefToId)(relation.ref)];
    const missing = [src ? undefined : (0, databaseUtils_1.relationLinkToEntityRef)(relation.src), ref ? undefined : (0, databaseUtils_1.relationLinkToEntityRef)(relation.ref)].filter(utils_1.isNotUndefined);
    return missing.length > 0 ? { relation, missing } : undefined;
}
//# sourceMappingURL=relationMissEntity.js.map